/**
 * Subscription refresh nudge (Wholesale only): reload with ?variant= so Shopify + subscription apps see the SKU.
 *
 * theme.liquid loads this for clnf_is_wholesale_b2b (same logic as the header Wholesale badge)
 * and sets data-clnf-subscription-banner="b2b" on <body>. JS also checks .wholesale-badge in the DOM.
 */

window.loadScheduler.onDomContentLoaded(function() {
  function shouldRunSubscriptionBanner() {
    if (document.body && document.body.getAttribute('data-clnf-subscription-banner') === 'b2b') {
      return true;
    }
    return !!document.querySelector('.wholesale-badge');
  }

  if (!shouldRunSubscriptionBanner()) {
    return;
  }

  const subscriptionBanner = document.getElementById('subscription-banner');
  const dismissBtn = document.getElementById('subscription-dismiss-btn');

  if (!subscriptionBanner || !dismissBtn) {
    return;
  }

  let bannerTimeout;
  let isBannerVisible = false;
  let nullVariantRetryCount = 0;
  /** Per variant id: after auto-dismiss / dismiss (×), do not auto-show again for that variant until reload. Switches to another variant ignore prior dismissals. */
  const nudgeDismissedForVariantId = Object.create(null);
  let lastCheckedVariantId = null;
  let subscriptionBannerBodyMo = null;

  const SESSION_STORAGE_KEY = 'subscription_banner_last_clicked_variant';
  const NULL_VARIANT_MAX_ATTEMPTS = 45;
  const NULL_VARIANT_RETRY_MS = 180;
  const MO_DEBOUNCE_MS = 450;

  function getParsedProductJson() {
    const el =
      document.querySelector('script.product-json[type="application/json"]') ||
      document.querySelector('script[type="application/json"].product-json') ||
      document.querySelector('[id^="ProductJson-"][type="application/json"]');
    if (!el || !el.textContent) {
      return null;
    }
    try {
      return JSON.parse(el.textContent.trim());
    } catch (e) {
      return null;
    }
  }

  /** Match product-custom.js / WeTheme: numeric Shopify variant id or null. */
  function coerceVariantId(raw) {
    if (raw == null || raw === '') return null;
    const n = Number(raw);
    return Number.isNaN(n) ? null : n;
  }

  function getWethemeProductFormEl() {
    const form = document.getElementById('AddToCartForm');
    if (form) {
      const wf = form.closest('wetheme-product-form');
      if (wf) return wf;
    }
    return (
      document.querySelector('.product-form-vue wetheme-product-form') ||
      document.querySelector('wetheme-product-form')
    );
  }

  /**
   * WeTheme: swatch updates hit Vue before the first spurious input[name="id"] from app blocks.
   * Same strategy as getVariantIdForStockNotify in product-custom.js.
   */
  function getVariantIdFromWethemeVue() {
    const wf = getWethemeProductFormEl();
    if (!wf || !wf.__vue__) return null;
    function tryVm(v) {
      if (!v) return null;
      let variant = v.variant;
      if (!variant && v.$data) variant = v.$data.variant;
      if (typeof v._data !== 'undefined' && !variant) variant = v._data.variant;
      if (variant && typeof variant === 'object' && variant.id != null) {
        return coerceVariantId(variant.id);
      }
      return null;
    }
    const rootVm = wf.__vue__;
    const fromRoot = tryVm(rootVm);
    if (fromRoot != null) return fromRoot;

    function walk(vm, depth) {
      if (!vm || depth > 12) return null;
      const ch = vm.$children;
      if (!ch || !ch.length) return null;
      for (let i = 0; i < ch.length; i++) {
        const c = ch[i];
        if (!c) continue;
        if (c.$el && c.$el.nodeType === 1 && !wf.contains(c.$el)) {
          continue;
        }
        let got = tryVm(c);
        if (got != null) return got;
        got = walk(c, depth + 1);
        if (got != null) return got;
      }
      return null;
    }
    return walk(rootVm, 0);
  }

  function getCanonicalVariantSelect(form) {
    const f = form || document.getElementById('AddToCartForm');
    if (!f) return null;
    return (
      f.querySelector("select.product-single__variants[name='id']") ||
      f.querySelector("select[id^='productSelect-'][name='id']") ||
      f.querySelector('select.product-single__variants') ||
      null
    );
  }

  /** Prefer input whose value is a real variant id from ProductJson (avoids app-injected name="id"). */
  function pickBestVariantIdInput(form) {
    if (!form) return null;
    const list = form.querySelectorAll('input[name="id"]');
    if (!list.length) return null;
    const product = getParsedProductJson();
    const valid = new Set();
    if (product && product.variants) {
      for (let i = 0; i < product.variants.length; i++) {
        const v = product.variants[i];
        if (v && v.id != null) valid.add(String(v.id));
      }
    }
    for (let j = 0; j < list.length; j++) {
      const inp = list[j];
      if (!inp || !inp.value) continue;
      const s = String(inp.value).trim();
      if (!valid.size || valid.has(s)) return inp;
    }
    if (valid.size) {
      for (let k = 0; k < list.length; k++) {
        const inp = list[k];
        if (!inp || !inp.value || inp.type !== 'hidden') continue;
        const s = String(inp.value).trim();
        if (valid.has(s)) return inp;
      }
      return null;
    }
    return list[0];
  }

  function getVariantIdFromUrl() {
    try {
      const u = new URL(window.location.href);
      const v = u.searchParams.get('variant');
      if (v && /^\d+$/.test(String(v).trim())) return String(v.trim());
    } catch (e) {}
    return null;
  }

  function parseAllowedGroupIds(attr) {
    if (!attr || typeof attr !== 'string') return [];
    return attr
      .split(',')
      .map(function(s) {
        return s.trim();
      })
      .filter(Boolean);
  }

  function filterAllocationsByAllowlist(allocations, allowIds) {
    if (!allowIds || allowIds.length === 0) {
      return allocations;
    }
    return allocations.filter(function(a) {
      const gid = a && a.selling_plan_group_id;
      if (gid == null) return false;
      const gStr = String(gid);
      for (let i = 0; i < allowIds.length; i++) {
        if (String(allowIds[i]) === gStr) return true;
      }
      return false;
    });
  }

  function getB2bBlockRoot() {
    return document.querySelector('[data-clnf-b2b-selling-plans]');
  }

  function b2bEligible(variantId) {
    if (variantId == null || variantId === '') return false;
    const root = getB2bBlockRoot();
    if (!root) return false;

    const scriptEl = root.querySelector('script[type="application/json"][data-clnf-b2b-plans-json]');
    if (!scriptEl || !scriptEl.textContent) return false;

    let data;
    try {
      data = JSON.parse(scriptEl.textContent.trim());
    } catch (e) {
      return false;
    }

    if (!data || !Array.isArray(data.variants)) return false;

    const vidStr = String(variantId);
    const row = data.variants.find(function(v) {
      return v && String(v.id) === vidStr;
    });
    if (!row || !Array.isArray(row.selling_plan_allocations)) return false;

    const allowAttr = root.getAttribute('data-allowed-group-ids') || '';
    const allowIds = parseAllowedGroupIds(allowAttr);
    const filtered = filterAllocationsByAllowlist(row.selling_plan_allocations, allowIds);
    return filtered.length > 0;
  }

  /**
   * When the B2B app JSON omits the client-selected variant row, Shopify ProductJson can still list allocations.
   *
   * IMPORTANT: For Wholesale-tag customers on the retail domain, the B2B block root may not render.
   * In that case, fall back to "any selling_plan_allocations" as the eligibility signal.
   */
  function productJsonEligibleForBanner(variantId) {
    if (variantId == null || variantId === '') return false;
    const product = getParsedProductJson();
    if (!product || !Array.isArray(product.variants)) return false;
    const vidStr = String(variantId);
    const pv = product.variants.find(function(v) {
      return v && String(v.id) === vidStr;
    });
    if (!pv || !Array.isArray(pv.selling_plan_allocations) || pv.selling_plan_allocations.length === 0) {
      return false;
    }

    const root = getB2bBlockRoot();
    if (!root) {
      return true;
    }

    const allowAttr = root.getAttribute('data-allowed-group-ids') || '';
    const allowIds = parseAllowedGroupIds(allowAttr);
    if (!allowIds || allowIds.length === 0) {
      return true;
    }

    const filtered = filterAllocationsByAllowlist(pv.selling_plan_allocations, allowIds);
    return filtered.length > 0;
  }

  function variantHasSubscriptionNudge(variantId) {
    return b2bEligible(variantId) || productJsonEligibleForBanner(variantId);
  }

  function getVariantIdsWithSellingPlansFromLiquid() {
    const el = document.querySelector('script[type="application/json"][data-clnf-variant-selling-plans]');
    if (!el || !el.textContent) return null;
    try {
      const data = JSON.parse(el.textContent.trim());
      const ids = data && data.variant_ids_with_selling_plans;
      if (!Array.isArray(ids)) return null;
      return ids.map(function(x) { return String(x); });
    } catch (e) {
      return null;
    }
  }

  function liquidEligibleForBanner(variantId) {
    if (variantId == null || variantId === '') return false;
    const ids = getVariantIdsWithSellingPlansFromLiquid();
    if (!ids || ids.length === 0) return false;
    const vidStr = String(variantId);
    for (let i = 0; i < ids.length; i++) {
      if (ids[i] === vidStr) return true;
    }
    return false;
  }

  function isVariantSubscriptionEligible(variantId) {
    return variantHasSubscriptionNudge(variantId) || liquidEligibleForBanner(variantId);
  }

  function mightHaveSubscriptionUi() {
    if (getB2bBlockRoot()) return true;
    if (getVariantIdsWithSellingPlansFromLiquid()) return true;
    return window.location.pathname.includes('/products/');
  }

  function getSelectedVariantId() {
    const fromVue = getVariantIdFromWethemeVue();
    if (fromVue != null) return String(fromVue);

    const form = document.getElementById('AddToCartForm');
    if (form) {
      const sel = getCanonicalVariantSelect(form);
      if (sel && sel.value) {
        const c = coerceVariantId(sel.value);
        if (c != null) return String(c);
      }
      const scopedSwatch = form.querySelector('.swatch-element input[type="radio"]:checked');
      if (scopedSwatch && scopedSwatch.value) {
        const c2 = coerceVariantId(scopedSwatch.value);
        if (c2 != null) return String(c2);
      }
      const hid = pickBestVariantIdInput(form);
      if (hid && hid.value) {
        const c3 = coerceVariantId(hid.value);
        if (c3 != null) return String(c3);
      }
    }

    const u = getVariantIdFromUrl();
    if (u) return u;

    const variantSelect =
      document.querySelector('select.product-single__variants') ||
      document.querySelector('select[name="id"]');
    if (variantSelect && variantSelect.value) {
      const c4 = coerceVariantId(variantSelect.value);
      if (c4 != null) return String(c4);
    }

    const selectedSwatch = document.querySelector('#AddToCartForm .swatch-element input[type="radio"]:checked');
    if (selectedSwatch && selectedSwatch.value) {
      const c5 = coerceVariantId(selectedSwatch.value);
      if (c5 != null) return String(c5);
    }

    return null;
  }

  function hasUserClickedBanner() {
    const currentVariantId = getSelectedVariantId();
    if (currentVariantId == null) return false;
    try {
      const lastClickedVariantId = sessionStorage.getItem(SESSION_STORAGE_KEY);
      return lastClickedVariantId && lastClickedVariantId === String(currentVariantId);
    } catch (e) {
      return false;
    }
  }

  function markBannerAsClicked() {
    const currentVariantId = getSelectedVariantId();
    if (currentVariantId != null) {
      try {
        sessionStorage.setItem(SESSION_STORAGE_KEY, String(currentVariantId));
      } catch (e) {
        // Storage unavailable (private mode security restrictions)
      }
    }
  }

  function showSubscriptionBanner() {
    const vidEarly = getSelectedVariantId();
    if (vidEarly == null || hasUserClickedBanner() || nudgeDismissedForVariantId[String(vidEarly)]) {
      return;
    }

    // Already showing: keep the current display + auto-dismiss timer. Do not re-run enter/exit (that was causing flicker).
    if (isBannerVisible) {
      return;
    }

    if (bannerTimeout) {
      clearTimeout(bannerTimeout);
      bannerTimeout = null;
    }

    subscriptionBanner.style.display = 'block';
    subscriptionBanner.offsetHeight;
    subscriptionBanner.classList.add('show');
    isBannerVisible = true;

    bannerTimeout = setTimeout(function() {
      hideSubscriptionBanner();
    }, 5000);
  }

  /**
   * @param {{ exhaustNudge?: boolean }} [options] - If exhaustNudge is false, only hide UI; do not suppress future nudges for this variant.
   */
  function hideSubscriptionBanner(options) {
    const exhaustNudge = !options || options.exhaustNudge !== false;

    if (!isBannerVisible) return;

    if (bannerTimeout) {
      clearTimeout(bannerTimeout);
      bannerTimeout = null;
    }

    if (exhaustNudge) {
      const vidDismiss = getSelectedVariantId();
      if (vidDismiss != null) {
        nudgeDismissedForVariantId[String(vidDismiss)] = true;
      }
    }

    subscriptionBanner.classList.remove('show');
    isBannerVisible = false;

    setTimeout(function() {
      subscriptionBanner.style.display = 'none';
    }, 400);
  }

  // Function to refresh so the server and Subscriptions app see the selected variant.
  // location.reload() alone keeps the URL without ?variant=; Shopify then renders the
  // default variant on the server and the subscription widget often stays empty for 25+ lb SKUs.
  function refreshPage() {
    markBannerAsClicked();
    const variantId = getSelectedVariantId();
    if (variantId) {
      try {
        const url = new URL(window.location.href);
        url.searchParams.set('variant', String(variantId));
        window.location.assign(url.toString());
      } catch (e) {
        const raw = (window.location.search || '').replace(/^\?/, '');
        const params = new URLSearchParams(raw);
        params.set('variant', String(variantId));
        window.location.assign(
          window.location.pathname + '?' + params.toString() + (window.location.hash || '')
        );
      }
      return;
    }
    window.location.reload();
  }

  subscriptionBanner.addEventListener('click', function(e) {
    if (e.target !== dismissBtn && !dismissBtn.contains(e.target)) {
      refreshPage();
    }
  });

  dismissBtn.addEventListener('click', function(e) {
    e.stopPropagation();
    hideSubscriptionBanner();
  });

  function checkVariantAndShowBanner() {
    if (!window.location.pathname.includes('/products/')) {
      hideSubscriptionBanner({ exhaustNudge: false });
      return;
    }

    const variantId = getSelectedVariantId();

    if (variantId == null) {
      if (mightHaveSubscriptionUi()) {
        nullVariantRetryCount++;
        if (nullVariantRetryCount < NULL_VARIANT_MAX_ATTEMPTS) {
          setTimeout(checkVariantAndShowBanner, NULL_VARIANT_RETRY_MS);
        } else {
          hideSubscriptionBanner({ exhaustNudge: false });
        }
        return;
      }
      nullVariantRetryCount = 0;
      hideSubscriptionBanner({ exhaustNudge: false });
      return;
    }

    nullVariantRetryCount = 0;

    if (lastCheckedVariantId != null && String(variantId) !== String(lastCheckedVariantId)) {
      if (bannerTimeout) {
        clearTimeout(bannerTimeout);
        bannerTimeout = null;
      }
      if (isBannerVisible) {
        hideSubscriptionBanner({ exhaustNudge: false });
      }
    }
    lastCheckedVariantId = variantId;

    if (isVariantSubscriptionEligible(variantId)) {
      showSubscriptionBanner();
    } else {
      hideSubscriptionBanner({ exhaustNudge: false });
    }
  }

  function bindFormChange() {
    const form = document.getElementById('AddToCartForm');
    if (form) {
      form.addEventListener('change', function() {
        setTimeout(checkVariantAndShowBanner, 50);
      });
    }
  }

  bindFormChange();

  document.addEventListener('change', function(e) {
    if (
      (e.target.matches && e.target.matches('select.product-single__variants')) ||
      (e.target.matches && e.target.matches('select[name="id"]')) ||
      (e.target.matches && e.target.matches('.swatch-element input[type="radio"]'))
    ) {
      setTimeout(checkVariantAndShowBanner, 100);
    }
  });

  document.addEventListener('click', function(e) {
    if (e.target.closest('#AddToCartForm .swatch-element')) {
      setTimeout(checkVariantAndShowBanner, 200);
    }
  });

  function onVariantEventForBanner() {
    setTimeout(checkVariantAndShowBanner, 0);
  }
  // WeTheme dispatches both; listening to only one misses updates when swatches drive state.
  document.addEventListener('variant:changed', onVariantEventForBanner);
  document.addEventListener('variant:change', onVariantEventForBanner);

  [320, 900, 2000, 3800].forEach(function(ms) {
    setTimeout(checkVariantAndShowBanner, ms);
  });

  checkVariantAndShowBanner();

  // Observe the narrowest available container; document.body is too broad and fires on every
  // DOM mutation on the page (cart drawer, header, unrelated sections) for the page's whole life.
  const subscriptionBannerMoRoot =
    document.getElementById('AddToCartForm') ||
    document.querySelector('.product-form-vue') ||
    document.querySelector('[id^="shopify-section-template--product"]') ||
    document.body;

  if (typeof MutationObserver !== 'undefined' && subscriptionBannerMoRoot) {
    let moTimer;
    subscriptionBannerBodyMo = new MutationObserver(function() {
      clearTimeout(moTimer);
      moTimer = setTimeout(checkVariantAndShowBanner, MO_DEBOUNCE_MS);
    });
    subscriptionBannerBodyMo.observe(subscriptionBannerMoRoot, { childList: true, subtree: true });
  }
});
